let copyTimer: any = null; // 타이머 저장용 변수
export let copy = (text: string, mgs: string) => {
    let doc = document.createElement("textarea");
    doc.textContent = text;
    document.body.append(doc);
    doc.select();
    document.execCommand("copy");
    doc.remove();

    let copyMsg = document.getElementById("copy-msg");

    // 기존 타이머가 있으면 클리어
    if (copyTimer) {
        clearTimeout(copyTimer);
    }

    // 기존 show 클래스 제거 (애니메이션 초기화)
    copyMsg.classList.remove("show");

    // 100ms 지연 후 다시 show 클래스 추가 (애니메이션이 보이도록)
    setTimeout(() => {
        copyMsg.textContent = mgs || "Copy completed!";
        copyMsg.classList.add("show");

        // 새로운 타이머 설정
        copyTimer = setTimeout(() => {
            copyMsg.classList.remove("show");
            copyTimer = null;
        }, 2000);
    }, 100); // 100ms 지연 추가
};

export let dateFormat = (timestamp: number) => {
    // console.log("Original timestamp:", timestamp);
    // check if timestamp is second or millisecond
    if (timestamp < 1e12) {
        timestamp *= 1000;
    }
    let currentDate = new Date(timestamp);
    let year = currentDate.getFullYear();
    let month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
    let day = ("0" + currentDate.getDate()).slice(-2);
    let dateStr = `${year}-${month}-${day}`;

    // console.log("Formatted date:", dateStr);

    return dateStr;
};

export function formatServiceId(serviceId: string, ownerId: string) {
    // format service ID
    const alphabet = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
    ];

    const regionKeys = [
        "us31",
        "us72",
        "ap51",
        "ap22",
        "ap41",
        "eu71",
        "ap21",
        "us32",
        "us71",
        "af51",
        "ap31",
        "ap43",
        "ap23",
        "ap42",
        "ca01",
        "eu01",
        "eu72",
        "eu51",
        "eu73",
        "eu11",
        "me51",
        "sa31",
    ];

    const regionIndex = regionKeys.indexOf(serviceId.slice(0, 4));
    const regionChar = alphabet[regionIndex];
    const subRegionId = serviceId.slice(4, -4);

    return `${subRegionId}-${regionChar}${serviceId.slice(-4)}-${ownerId}`;
}

/**
 * Compose a storage path to NFC before it becomes an S3 key or a "src::" record id.
 *
 * macOS reports filenames DECOMPOSED: 운전면허-김대현.jpg arrives as 24 loose jamo where the
 * composed form is 12 syllables. Windows and Korean IMEs produce the composed form. Both render
 * identically on screen, so the difference is invisible until something matches bytes.
 *
 * Two things then go wrong. Every id lookup here is byte-exact, so the two spellings of one file
 * never collide. And the agent, handed loose jamo, has to REASSEMBLE them to write a link back:
 * measured at 1136/1137 correct on composed Korean paths, but on the one decomposed path it
 * dropped a syllable and drifted three others, linking to a file that does not exist.
 *
 * Normalize at CAPTURE, not later. The upload key and the "src::" id are derived separately from
 * this same string, so composing it here keeps them identical by construction. Composing only one
 * of them produces a record that points at an object that is not there. NFC is canonically
 * equivalent, so nothing about the name's meaning or display changes.
 */
export function normalizeStoragePath(value: string): string {
	if (!value) return value;
	try { return value.normalize('NFC'); } catch (e) { return value; }
}
